// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-6dc5c9e6] .el-upload--picture-card {\n  width: 100px;\n  height: 100px;\n  line-height: 100px;\n}\n[data-v-6dc5c9e6] .el-upload-list__item {\n  width: 100px;\n  height: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
